import React from 'react';

type Props = {
  structureName: string;
  structureGeographicAddress: string;
  structurePCcode:string;
  onClick: () => void;
  selected: boolean,
  disabled: boolean,
};

const StructureButton = (props: Props): JSX.Element => (
  <div className={`structure-button ${props.selected || props.disabled ? 'selected' : ''} ${props.disabled ? 'disabled' : ''}`} onClick={props.onClick}>
    <div className="structure-name">
      <span className="name">{props.structureName}</span>
      <span className={`circle ${props.selected || props.disabled ? 'selected' : ''}`} />
    </div>

    <div className="structure-address">
      <div>{props.structureGeographicAddress ? props.structureGeographicAddress : ''}</div>
      <div>{props.structurePCcode ? props.structurePCcode : ''}</div>
    </div>
  </div>
);

export default StructureButton;
